import React, { useState } from 'react';
import { X, Plus, Trash2 } from 'lucide-react';
import './logistics-modals.css';

const AddSensorModal = ({ onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    type: 'Fuel',
    size: ''
  });

  const [calibrationRows, setCalibrationRows] = useState([
    { value: 0, voltage: 0 },
    { value: 0, voltage: 0 }
  ]);

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) setErrors({ ...errors, [e.target.name]: null });
  };

  const handleCalibrationChange = (index, field, val) => {
    const updatedRows = [...calibrationRows];
    updatedRows[index][field] = val;
    setCalibrationRows(updatedRows);
  };

  const addRow = () => {
    setCalibrationRows([...calibrationRows, { value: 0, voltage: 0 }]);
  };

  const removeRow = (index) => {
    const updatedRows = calibrationRows.filter((_, i) => i !== index);
    setCalibrationRows(updatedRows);
  };

  const handleSubmit = () => {
    if (!formData.name.trim()) {
      setErrors({ name: 'Name is required.' });
      return;
    }
    const finalData = { ...formData, calibration: calibrationRows };
    onSubmit(finalData);
  };

  const getValueLabel = () => {
    if (formData.type === 'Temperature') return 'Temperature';
    if (formData.type === 'Load') return 'Load';
    return 'Fuel';
  };

  return (
    /* Unique Namespace Root */
    <div className="ls-sensor-modal-root">
      <div className="ls-modal-overlay">
        <div className="ls-modal-content" style={{ maxWidth: '900px' }}>
          
          <div className="ls-modal-header">
            <h3>Add Sensor</h3>
            <button className="ls-close-btn" onClick={onClose}>&times;</button>
          </div>

          <div className="ls-modal-body">
            <div className="ls-form-grid-3">
              <div className="ls-form-group">
                <label>Name</label>
                <input 
                  type="text" 
                  name="name" 
                  className={`ls-form-control ${errors.name ? 'ls-is-invalid' : ''}`}
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && <span className="ls-error-text">* {errors.name}</span>}
              </div>

              <div className="ls-form-group">
                <label>Sensor Type</label>
                <select 
                  name="type" 
                  className="ls-form-control" 
                  value={formData.type} 
                  onChange={handleChange}
                >
                  <option value="Fuel">Fuel</option>
                  <option value="Temperature">Temperature</option>
                  <option value="Load">Load</option>
                </select>
              </div>

              <div className="ls-form-group">
                <label>Size</label>
                <input 
                  type="text" 
                  name="size" 
                  className="ls-form-control" 
                  value={formData.size} 
                  onChange={handleChange} 
                />
              </div>
            </div>

            <div className="ls-calibration-section">
              <div className="ls-calib-header">
                <h4>{formData.type} Calibration</h4>
                <button onClick={addRow} className="ls-btn-add-row" title="Add Row">
                  <Plus size={16} color="#4f46e5" />
                </button>
              </div>

              <div className="ls-calibration-list">
                {calibrationRows.map((row, index) => (
                  <div key={index} className="ls-calibration-row">
                    <div className="ls-form-group" style={{ flex: 1 }}>
                      <label>{getValueLabel()}</label>
                      <input 
                        type="number" 
                        className="ls-form-control" 
                        value={row.value} 
                        onChange={(e) => handleCalibrationChange(index, 'value', e.target.value)}
                      />
                    </div>

                    <div className="ls-form-group" style={{ flex: 1 }}>
                      <label>Voltage</label>
                      <input 
                        type="number" 
                        className="ls-form-control" 
                        value={row.voltage} 
                        onChange={(e) => handleCalibrationChange(index, 'voltage', e.target.value)}
                      />
                    </div>

                    <div className="ls-remove-wrapper">
                      {calibrationRows.length > 1 && (
                        <button onClick={() => removeRow(index)} className="ls-trash-btn" title="Remove Row">
                          <Trash2 size={18} />
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="ls-modal-footer">
            <button className="ls-btn ls-btn-submit" onClick={handleSubmit}>SUBMIT</button>
            <button className="ls-btn ls-btn-cancel" onClick={onClose}>CANCEL</button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AddSensorModal;